import { TecLoader } from "./TechLoader";
import { TecItemCreate } from "./TecItemCreate";
import { TweenMax } from "gsap";
import CarouselMv from "../utils/CarouselMv";
import Carousel from "../utils/carousel";

/**
 * [PointOfViewに表示する技業log]
 *
 * @export
 * @class TecPointOfView
 */
export class TecPointOfView {
  private target;
  private main;

  constructor( target ) {
    this.target = target;
    this.main = this.target.find('.carousel ul')
    this.target.empty();
    new TecLoader( (data)=> { this.onData(data) } );
  }

  /**
   * データ取得完了。オブジェクト作成
   * @param {*} data
   * @memberof TechIndex
   */
  public onData(data):void {
    let i:number;
    let mv_src:string = '';

    // 表示要素生成
    var src:TecItemCreate = new TecItemCreate();
    var src_create = src.createItem(data);
    var src_create_mv = src_create.src_data;

    for(i = 0; i < 3; i++) {
      let mv = src_create_mv[i];
      let hrefTarget = '';
      if(mv.url.includes('/gpu/')) hrefTarget = ' target="_blank"'
      mv_src += `
                <li class="swiper-slide">
            <a href="${ mv.url}"${hrefTarget}>
            <div class="m_photoBox__img"><img src="${mv.thumb}" alt="${mv.title}"></div>
            <div class="m_photoBox__inner">
            <p class="m_photoBox__title">${mv.title}</p>
            <ul class="m_photoBox__category">
            ${mv.tag}
            </ul>
            <div class="m_photoBox__writerWrap">
            <div class="m_photoBox__writer">
            ${mv.writer}
            </div>
            </div>
            <p class="m_photoBox__text m_photoBox__text--date">${mv.date}</p>
            </div>
            </a>
            </li>
            `;
    }


    // this.main.append( mv_src );
    this.target.append( mv_src );


    // new Carousel( this.main );
  }
}